export default {
    baseURL: import.meta.env.VUE_APP_API_BASE_URL,
}
